import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form'; // <-- Import `useForm` here
import { useNavigate } from 'react-router-dom'; 
import { Audio } from 'react-loader-spinner';
import { BsBank } from "react-icons/bs";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { FaRegBuilding } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md"; // <-- NEW: Import for the close icon
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Layout, DynamicForm, CompanyProfile, CompanyProfileConfig, BankProfile, BankConfig} from '../../../../components';
import {handleApi, getChangedFields} from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/style.css';

const Settings = () => {
  const { reset, control, register, handleSubmit, formState: { errors } } = useForm();
  const { userData, companyProfile, bank, currentColor, actionCount, setSuppressAutoNavigate, setActionCount } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [initialBank, setInitialBank] = useState(bank[0]);
  const [displayImg, setDisplayImg] = useState(''); 
  const [imgType, setImgType] = useState('');
  const [activeTab, setActiveTab] = useState('company');
  const [settings, setSettings] = useState({
    bankDetail: BankProfile,
    companyProfile: companyProfile,
    taxDetail: {}
  });
 
  console.log('Data received from context sir :', bank[0]); 
  const [originalProfile, setOriginalProfile] = useState(companyProfile);
  setSuppressAutoNavigate(true); // prevent auto redirect
  const navigate = useNavigate(); 

  useEffect(() => {
    setIsLoading(true);
    setIsLoading(false);
  }, [companyProfile]);

  const convertFile = (files) => {
    if (files && files.length > 0 && files[0] instanceof File) {
      const fileRef = files[0];
      const fileType = fileRef.type;
      const reader = new FileReader();
      reader.readAsBinaryString(fileRef);
      reader.onload = (ev) => {
        const photo = {
          data: btoa(ev.target.result),
          contentType: fileType
        };
        setDisplayImg(btoa(ev.target.result));
        setImgType(fileType);
        setSettings(prevSettings => ({
          ...prevSettings,
          companyProfile: {
            ...prevSettings.companyProfile,
            photo: photo
          }
        }));
      };
    }
  };

  // handle closing the page
  const handleClosePage = () => {navigate(-1);  };  // Navigate back to the previous page
  

  const handleImgChange = (event) => {
    const { name, files } = event.target;
    if (name === "logo") {
      convertFile(files);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
  
    setSettings((prev) => {
      if (activeTab === 'company') {
        return {
          ...prev,
          companyProfile: {
            ...prev.companyProfile,
            [name]: value,
          },
        };
      } else if (activeTab === 'bank') {
        return {
          ...prev,
          bankDetail: {
            ...prev.bankDetail,
            [name]: value,
          },
        };
      }
      return prev;
    });
  };
  
  // Handle the cancel action
  const handleBankCancel = () => {
    // Create an object with default values for each field from ProductConfig
    const resetValues = BankConfig.reduce((acc, field) => {
      acc[field.name] = field.defaultValue === undefined ? '' : field.defaultValue; // Handle undefined defaultValue
      // Special handling for date fields if defaultValue is not suitable for empty
      if (field.type === 'date') {
        acc[field.name] = ''; // Or null, depending on how you want to represent empty date
      }
      return acc;
    }, {});
    // Reset the form state with default values
    reset(resetValues); // This will clear the react-hook-form state
    // Optionally reset Bank state as well, to ensure consistency and trigger useEffect if needed
    setInitialBank({});
  };


  const handleCompanyFormSubmit = async (data) => {
    console.log('data in company submit',data)
    const { 
      create_uid,create_date,update_date,photo_url,
      ...payload } = data;
    console.log('payload to send', payload);
    const apiMethod = data.id ? 'PUT' : 'POST';
    const parameters = { ...(data.id && { id: data.id }) };
    setIsLoading(true);
    try {
      const response = await handleApi('company_profile', payload, userData, apiMethod, parameters);
      if (response.status === 200) {toast.success('Company profile updated successfully.');
      } else {toast.error('Error saving bank.', response.statusText);}
    } catch (error) {
      toast.error('Error saving bank: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };

  const handleBankFormSubmit = async (data) => {
    console.log('data',data)
    const { terms_accepted, ...payload } = data;
    console.log('payload to send', payload);
    const apiMethod = data.id ? 'PUT' : 'POST';
    const parameters = { ...(data.id && { id: data.id }) };
    setIsLoading(true);
    try {
      const response = await handleApi('bank_accounts', payload, userData, apiMethod, parameters);
      if (response.status === 200) {toast.success('Bank updated successfully.');
      } else {toast.error('Error saving bank.', response.statusText);}
    } catch (error) {
      toast.error('Error saving bank: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  };

  /*const handleCompanyFormSubmit = async (e) => {
    e.preventDefault();
    console.log('here sir in submit ')
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (!companyProfile.name) {
      toast.error('Please enter company name');
      return;
    }

    const changedFields = getChangedFields(originalProfile, settings.companyProfile);
    const apiMethod = settings.companyProfile.id ? 'PUT' : 'POST';
    const parameters = { id: settings.companyProfile.id };

    setIsLoading(true);
    try {
      const response = await handleApi('company_profile', changedFields, userData, apiMethod, parameters);
      if (response.status === 200) {toast.success('Company updated successfully.');
      } else {toast.error('Error saving company.', response.statusText);}
    } catch (error) {
      toast.error('Error saving company: ' + error.message);
    } finally {
      setActionCount(actionCount + 1);
      setIsLoading(false);
    }
  }; */

  const photo = displayImg ? `data:${imgType};base64,${displayImg}` : companyProfile.photo_url;
  const tabs = [
    {
      title: 'Profile',
      key: 'company',
      icon: FaRegBuilding,
      content: (
        <CompanyProfile
          fields={CompanyProfileConfig}
          photo={photo}
          onChange={handleChange}
          companyProfileData={settings.companyProfile} // <-- not from context
          handleImgChange={handleImgChange}
          onSubmit={handleCompanyFormSubmit}
          isLoading={isLoading}
        />

      ),
    },
    {
      title: 'Bank',
      key: 'bank',
      icon: BsBank,
      content: (
        <BankProfile
          bankData={initialBank}
          fields={BankConfig}
          control={control}
          register={register}
          onSubmit={handleBankFormSubmit}
          isLoading={isLoading}
          onChange={handleChange}
          onCancel={handleBankCancel} // Pass the proper clearing function here
          errors={errors} // <-- Pass `errors` down
          reset={reset} // <-- NEW: Pass the `reset` function from `useForm`
        />
     
      ),
             
    },
    {
      title: 'Tax',
      key: 'tax',
      icon: HiOutlineReceiptTax,
      content: (
        <div className="text-center text-cyan-200 text-lg">
          <p>Tax Details Form - Coming Soon</p>
        </div>
      ),
    },
  ];

  return (
    <Layout>
      <div className="m-2 sm:m-4">
        <div className="relative flex justify-between items-center">
                  <h1 className="text-center font-bold flex-grow">COMPANY SETTINGS</h1>
                  <button
                    onClick={handleClosePage}
                    className="p-1 rounded-lg text-red-400 bg-white hover:bg-gray-50 hover:text-gray-600"
                  >
                    <MdOutlineCancel color={currentColor} size={30} />
                  </button>
                </div>

        {/* Tab Buttons */}
        <div className="flex justify-center my-4 space-x-6 text-white">
          {tabs.map(tab => (
            <button
              key={tab.key}
              className={`flex items-center gap-2 px-4 py-2 rounded-full transition-all duration-200 shadow-md ${
                activeTab === tab.key ? 'ring-2 ring-white' : 'opacity-80 hover:opacity-100'
              }`}
              onClick={() => setActiveTab(tab.key)}
              style={{ backgroundColor: currentColor }}
            >
              <tab.icon /> {tab.title}
            </button>
          ))}
        </div>

        <ToastContainer position="top-center" autoClose={2000} />

        {isLoading ? (
          <div className="flex items-center flex-col py-6">
            <Audio height="80" width="80" radius="9" color={currentColor} ariaLabel="loading" />
            <p className="mt-2 text-white">Loading. Please wait...</p>
          </div>
        ) : (
          <div className="bg-white p-4 sm:p-6 my-6 my-auto mx-auto max-w-[80%] rounded-xl shadow-2xl">
            <main className="p-4">
              <div className="max-w-4xl mx-auto border-b border-gray-400 bg-gray-500 transition-all duration-200 cursor-pointer rounded-xl shadow-2xl p-8">
                {/* Render Active Tab Content */}
                {tabs.find(tab => tab.key === activeTab)?.content}
              </div>
            </main>
          </div>
        )}
      </div>
    </Layout>
  );
};
export default Settings;